import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import md5 from "md5";
// * hooks
import { useAuth } from "../services/auth";
import { firebaseAuth } from "../services/firebase";
// * assets
import LoginImage from "../assets/image/login.png";
import { toast } from "react-toastify";

const LogIn = () => {
  const { signIn, authData } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (authData?.token) {
      navigate("/admin");
    } else {
      const oldAuth = localStorage.getItem("mybranz_auth");
      if (oldAuth) {
        signIn(JSON.parse(oldAuth));
      }
    }
  }, [authData, navigate, signIn]);

  const signInWithGoogleAuth = useCallback(
    async (re: any) => {
      const email = re.user.email;
      if (email === "jana.kmr@gmail.com" || email === "haoyu0307@gmail.com") {
        const newAuth = {
          name: re.user.displayName,
          email,
          token: md5(re.user.uid),
        };
        localStorage.setItem("mybranz_auth", JSON.stringify(newAuth));
        signIn(newAuth);
      } else {
        toast.error("Sorry, you don't have access");
      }
    },
    [signIn]
  );

  const onGoogleAuth = useCallback(async () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(firebaseAuth, provider)
      .then((re) => {
        signInWithGoogleAuth(re);
      })
      .catch((_) => {});
  }, [signInWithGoogleAuth]);

  return (
    <div className="h-screen flex flex-row">
      <img
        src={LoginImage}
        alt="login"
        className="h-screen w-1/2 object-cover"
      />
      <div className="flex-1 px-12 flex flex-col justify-center">
        <h2 className="text-2xl">Login</h2>
        <div
          onClick={onGoogleAuth}
          className="mt-4 py-1 w-40 rounded-md border border-blue-400 flex flex-row justify-center cursor-pointer"
        >
          Google Login
        </div>
      </div>
    </div>
  );
};

export default LogIn;
